module.exports = __webpack_public_path__ + "static/media/prompt_p.bc9e46da.png";